import { useAuth } from "@/contexts/AuthContext";
import SuperAdminDashboard from "./SuperAdminDashboard";
import CompanyAdminDashboard from "./CompanyAdminDashboard";
import CADashboard from "./CADashboard";
import AccountantDashboard from "./AccountantDashboard";

const DashboardHome = () => {
  const { role } = useAuth();

  switch (role) {
    case "super_admin":
      return <SuperAdminDashboard />;
    case "company_admin":
      return <CompanyAdminDashboard />;
    case "ca":
      return <CADashboard />;
    case "accountant":
      return <AccountantDashboard />;
    default:
      return <CompanyAdminDashboard />;
  }
};

export default DashboardHome;
